module.exports = __webpack_public_path__ + "static/img/home2.c8ccf7aa.png";